export const COLORS = {
  deepNavy: '#1F2F49',
  steelNavy: '#3C5880',
  primaryNavy: '#2A3F5D',
  white: '#FFFFFF',
  textPrimary: '#181D27',
  blueSteel: '#A7B0B9',
  pureLight: '#F7F8FA',
  softGrey: '#E4E6EB',
  brandOrange: '#C94021',
  mint: '#0D803B',
  softShadow: 'rgba(18, 38, 63, 0.06)',
  overlay: 'rgba(24, 29, 39, 0.35)',
  borderMuted: '#D8DDE5',
  slate: '#556987',
};

/**
 * White card surface used by the Operations tabs (Inflow / Withdraw /
 * Top-up / Exchange): soft shadow, no border. Spread it into a style and
 * add the layout properties the tile needs.
 */
export const CARD_SURFACE = {
  backgroundColor: COLORS.white,
  borderRadius: 12,
  shadowColor: COLORS.softShadow,
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 1,
  shadowRadius: 8,
  elevation: 2,
} as const;
